const CheckCircleIcon = ({ stroke = '#12B76A', size = '22' }: { stroke?: string; size?: string }) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="10.5" fill={stroke} stroke={stroke} />
    <path
      d="M15.6654 7.5L9.2487 13.9167L6.33203 11"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckCircleIcon;
